import React, { useState } from 'react';
import { Package, ChevronRight, Sparkles, X, CheckCircle, Clock, Wrench } from 'lucide-react';
import { MobileLayout } from '../components/MobileLayout';
export function AbbonamentiPage() {
  const [showStoricoModal, setShowStoricoModal] = useState(false);
  const [activeTab, setActiveTab] = useState<'pulizie' | 'interventi'>('pulizie');
  // Mock data for available cleanings
  const availableCleanings = 13;
  const totalCleanings = 20;
  const progressPercent = availableCleanings / totalCleanings * 100;
  // Mock data for cleaning breakdown
  const cleaningBreakdown = [{
    count: 3,
    expiryDate: '15 Mar 2024'
  }, {
    count: 10,
    expiryDate: '20 Mag 2024'
  }];
  // Mock data for consumption history
  const consumptionHistory = [{
    id: '1',
    date: '10 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '2',
    date: '8 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '3',
    date: '5 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '4',
    date: '2 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '5',
    date: '28 Dic 2023',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }];
  // Mock data for extraordinary interventions history
  const extraordinaryHistory = [{
    id: '1',
    icon: '⚡',
    title: 'Lampadina bagno',
    date: '15 Gen 2024',
    price: '€35',
    status: 'Completato'
  }, {
    id: '2',
    icon: '🧹',
    title: 'Deep cleaning',
    date: '10 Gen 2024',
    price: '€120',
    status: 'Completato'
  }, {
    id: '3',
    icon: '🔧',
    title: 'Riparazione rubinetto',
    date: '5 Gen 2024',
    price: '€85',
    status: 'Completato'
  }];
  // Cleaning package options
  const cleaningPackages = [{
    id: '1',
    cleanings: 10,
    price: 299,
    validity: '3 mesi',
    discount: null,
    popular: false
  }, {
    id: '2',
    cleanings: 15,
    price: 399,
    validity: '4 mesi',
    discount: '10%',
    popular: true
  }, {
    id: '3',
    cleanings: 30,
    price: 699,
    validity: '6 mesi',
    discount: '20%',
    popular: false
  }];
  // Intervention package options
  const interventionPackages = [{
    id: '1',
    name: 'Base',
    hours: 5,
    price: 149,
    validity: '3 mesi',
    discount: null,
    popular: false
  }, {
    id: '2',
    name: 'Standard',
    hours: 10,
    price: 279,
    validity: '6 mesi',
    discount: '10%',
    popular: true
  }, {
    id: '3',
    name: 'Premium',
    hours: 20,
    price: 499,
    validity: '12 mesi',
    discount: '15%',
    popular: false
  }];
  return <MobileLayout data-id="element-801">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-802">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-803">Abbonamenti</h1>
        <p className="text-xs lg:text-sm text-gray-500 mt-1" data-id="element-804">
          Gestisci i tuoi pacchetti pulizie
        </p>
      </div>

      {/* Active Package Card */}
      <div className="w-full lg:w-1/2 bg-white border border-border rounded-xl shadow-sm p-4 lg:p-5 mb-6" data-id="element-805">
        <div className="flex items-center justify-between mb-4" data-id="element-806">
          <div className="flex items-center gap-2" data-id="element-807">
            <Package size={18} className="text-teal-deep" data-id="element-808" />
            <h2 className="text-sm font-medium text-navy" data-id="element-809">Pacchetto Attivo</h2>
          </div>
          <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded-full" data-id="element-810">
            Attivo
          </span>
        </div>

        {/* Usage this month - New layout */}
        <div className="mb-4" data-id="element-811">
          <div className="flex items-center justify-between mb-2" data-id="element-812">
            <span className="text-sm text-gray-600" data-id="element-813">Utilizzo questo mese</span>
            <span className="text-sm font-semibold text-navy" data-id="element-814">
              {totalCleanings - availableCleanings} / {totalCleanings}
            </span>
          </div>
          {/* Progress bar */}
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-815">
            <div className="bg-teal-deep h-2 rounded-full transition-all duration-300" style={{
            width: `${(totalCleanings - availableCleanings) / totalCleanings * 100}%`
          }} data-id="element-816"></div>
          </div>
        </div>

        {/* CTA to view details */}
        <button onClick={() => setShowStoricoModal(true)} className="w-full flex items-center justify-between py-3 px-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors text-sm text-gray-600 hover:text-navy" data-id="element-817">
          <span data-id="element-818">Vedi dettaglio interventi</span>
          <ChevronRight size={18} className="text-gray-400" data-id="element-819" />
        </button>
      </div>

      {/* Tab Navigation for Packages - Underline style */}
      <div className="flex items-center gap-6 mb-6 overflow-x-auto pb-1" data-id="element-820">
        <button onClick={() => setActiveTab('pulizie')} className={`pb-3 text-sm font-medium whitespace-nowrap transition-all flex items-center gap-2 border-b-2 ${activeTab === 'pulizie' ? 'border-teal-deep text-teal-deep' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-821">
          <Package size={16} data-id="element-822" />
          Pulizie
        </button>
        <button onClick={() => setActiveTab('interventi')} className={`pb-3 text-sm font-medium whitespace-nowrap transition-all flex items-center gap-2 border-b-2 ${activeTab === 'interventi' ? 'border-teal-deep text-teal-deep' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-823">
          <Wrench size={16} data-id="element-824" />
          Interventi
        </button>
      </div>

      {/* Pulizie Tab */}
      {activeTab === 'pulizie' && <div className="space-y-4" data-id="element-825">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-2" data-id="element-826">
            Aggiungi pulizie
          </div>

          {cleaningPackages.map(pkg => <div key={pkg.id} className={`bg-white rounded-xl shadow-sm p-4 relative transition-all ${pkg.popular ? 'border-2 border-coral' : 'border border-border'}`} data-id="element-827">
              {pkg.popular && <span className="absolute -top-2.5 left-4 bg-coral text-white text-xs px-2 py-0.5 rounded-full font-medium flex items-center gap-1" data-id="element-828">
                  <Sparkles size={10} data-id="element-829" />
                  Più scelto
                </span>}

              <div className="flex items-center justify-between" data-id="element-830">
                <div className="flex-1" data-id="element-831">
                  <div className="text-sm font-semibold text-navy mb-0.5" data-id="element-832">
                    +{pkg.cleanings} pulizie
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-833">
                    Validità {pkg.validity}
                  </div>
                </div>

                <div className="flex items-center gap-3" data-id="element-834">
                  <div className="text-right" data-id="element-835">
                    <div className="text-sm font-semibold text-coral" data-id="element-836">
                      €{pkg.price}
                    </div>
                    {pkg.discount && <div className="text-xs text-coral" data-id="element-837">-{pkg.discount}</div>}
                  </div>
                  <button className={`px-4 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] ${pkg.popular ? 'bg-coral text-white hover:bg-coral-600' : 'bg-gray-100 text-navy hover:bg-gray-200'}`} data-id="element-838">
                    Acquista
                  </button>
                </div>
              </div>
            </div>)}
        </div>}

      {/* Interventi Tab */}
      {activeTab === 'interventi' && <div className="space-y-4" data-id="element-839">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-2" data-id="element-840">
            Pacchetti ore interventi
          </div>

          {interventionPackages.map(pkg => <div key={pkg.id} className={`bg-white rounded-xl shadow-sm p-4 relative transition-all ${pkg.popular ? 'border-2 border-coral' : 'border border-border'}`} data-id="element-841">
              {pkg.popular && <span className="absolute -top-2.5 left-4 bg-coral text-white text-xs px-2 py-0.5 rounded-full font-medium flex items-center gap-1" data-id="element-842">
                  <Sparkles size={10} data-id="element-843" />
                  Più scelto
                </span>}

              <div className="flex items-center justify-between" data-id="element-844">
                <div className="flex-1" data-id="element-845">
                  <div className="text-sm font-semibold text-navy mb-0.5" data-id="element-846">
                    {pkg.name} - {pkg.hours} ore
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-847">
                    Validità {pkg.validity}
                  </div>
                </div>

                <div className="flex items-center gap-3" data-id="element-848">
                  <div className="text-right" data-id="element-849">
                    <div className="text-sm font-semibold text-coral" data-id="element-850">
                      €{pkg.price}
                    </div>
                    {pkg.discount && <div className="text-xs text-coral" data-id="element-851">-{pkg.discount}</div>}
                  </div>
                  <button className={`px-4 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] ${pkg.popular ? 'bg-coral text-white hover:bg-coral-600' : 'bg-gray-100 text-navy hover:bg-gray-200'}`} data-id="element-852">
                    Acquista
                  </button>
                </div>
              </div>
            </div>)}

          <p className="text-xs text-gray-500 mt-4 p-3 bg-gray-50 rounded-lg" data-id="element-853">
            I pacchetti interventi includono manutenzione, riparazioni e servizi
            extra. Le ore vengono scalate in base alla durata dell'intervento.
          </p>
        </div>}

      {/* Storico Modal */}
      {showStoricoModal && <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setShowStoricoModal(false)} data-id="element-854">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-lg max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-855">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-856">
              <h2 className="text-lg font-bold text-navy" data-id="element-857">
                Storico Interventi
              </h2>
              <button onClick={() => setShowStoricoModal(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-858">
                <X size={20} className="text-gray-500" data-id="element-859" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex-1 overflow-y-auto p-4 space-y-6" data-id="element-860">
              {/* Scadenze */}
              <div data-id="element-861">
                <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-3" data-id="element-862">
                  Scadenze
                </div>
                <div className="space-y-2" data-id="element-863">
                  {cleaningBreakdown.map((item, index) => <div key={index} className="flex items-center justify-between text-sm p-3 bg-gray-50 rounded-lg" data-id="element-864">
                      <div className="flex items-center gap-2 text-gray-600" data-id="element-865">
                        <Clock size={14} className="text-gray-400" data-id="element-866" />
                        <span data-id="element-867">{item.count} pulizie</span>
                      </div>
                      <span className="text-gray-400" data-id="element-868">
                        scadono il {item.expiryDate}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Storico Pulizie */}
              <div data-id="element-869">
                <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-3" data-id="element-870">
                  Storico Pulizie
                </div>
                <div className="space-y-2" data-id="element-871">
                  {consumptionHistory.map(item => <div key={item.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0" data-id="element-872">
                      <div className="flex items-center gap-3" data-id="element-873">
                        <div className="w-8 h-8 rounded-full bg-teal-deep/10 flex items-center justify-center" data-id="element-874">
                          <CheckCircle size={14} className="text-teal-deep" data-id="element-875" />
                        </div>
                        <div data-id="element-876">
                          <div className="text-sm font-medium text-navy" data-id="element-877">
                            {item.property}
                          </div>
                          <div className="text-xs text-gray-400" data-id="element-878">
                            {item.type}
                          </div>
                        </div>
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-879">{item.date}</div>
                    </div>)}
                </div>
              </div>

              {/* Interventi Straordinari */}
              <div data-id="element-880">
                <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-3" data-id="element-881">
                  Interventi Straordinari
                </div>
                <div className="space-y-2" data-id="element-882">
                  {extraordinaryHistory.map(item => <div key={item.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0" data-id="element-883">
                      <div className="flex items-center gap-3" data-id="element-884">
                        <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center text-base" data-id="element-885">
                          {item.icon}
                        </div>
                        <div data-id="element-886">
                          <div className="text-sm font-medium text-navy" data-id="element-887">
                            {item.title}
                          </div>
                          <div className="text-xs text-gray-400" data-id="element-888">
                            {item.date}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-889">
                        <div className="text-sm font-semibold text-navy" data-id="element-890">
                          {item.price}
                        </div>
                        <div className="text-xs text-green-600" data-id="element-891">
                          {item.status}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>}
    </MobileLayout>;
}